import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PermissionInterface } from '../interfaces/permission.interface';
import { ApiService } from './api.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  public permissionsLoaded: boolean = false;
  public permissions: PermissionInterface;
  public hasRestrictedAccess: boolean = false;

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private storageService: StorageService
  ) {
    this.permissions = this.storageService.get('permissions');
    if (this.storageService.get('isRestrictedAccessAccount')) {
      this.hasRestrictedAccess = true;
    }
  }

  public setPermissionsToDefaultIfNone(): void {
    if (this.permissions == null) {
      this.storageService.set('permissions', {
        ograniczoneUprawnienia: true,
        umowy: false,
        kpo: false,
        faktury: false,
      });
    } else {
      this.permissionsLoaded = true;
    }
  }

  public async loadPermissions(): Promise<void> {
    if (this.permissionsLoaded) {
      return;
    }

    // non-EMKA clients have access to all features in the menu, but navigating to them
    // shows a custom page instead of providing the feature
    if (this.hasRestrictedAccess) {
      this.permissions = {
        ograniczoneUprawnienia: true,
        umowy: true,
        kpo: true,
        faktury: true,
      };
    } else {
      this.permissions = await this.fetchPermissions();
    }

    this.storageService.set('permissions', this.permissions);
  }

  private fetchPermissions(): Promise<any> {
    const token = this.storageService.get('token');
    const lang = this.storageService.getPersistent('lang');

    return this.http
      .get(this.apiService.api + '/api/Umowa/PobierzUprawnienia', {
        params: {
          Jezyk: lang,
        },
        headers: {
          Token: token,
        },
      })
      .toPromise();
  }
}
